import React, { Fragment } from "react";
import { Link } from "react-router-dom";

import { Helmet } from "react-helmet";

import NavbarB from "../components/navbar-b";
import FooterB from "../components/footer-b";
import "./micro-residency.css";

const MicroResidency = (props) => {
  return (
    <div className="microres-container">
      <Helmet>
        <title>Micro-Residency - FF Season 2026</title>
        <meta property="og:title" content="Micro-Residency - FF Season 2026" />
        <link
          rel="canonical"
          href="https://feelers-feelers.com/micro-residency"
        />
      </Helmet>
      <div className="microres-bg-container">
        <img
          src="/machineyearning/MY-main-bg.jpg"
          className="microres-image-bg"
        />
      </div>
      <div className="microres-navbar-container">
        <NavbarB rootClassName="navbar-broot-class-name6"></NavbarB>
      </div>
      <div className="microres-body">
        <div className="microres-body-back MY-Subtitle">
          <Link to="/">&lt; BACK</Link>
        </div>
        <div className="microres-body-content">
          <span className="microres-text-title MY-Subtitle">
            SEASON SPECIAL
          </span>
          <span className="microres-text-title MY-Headline">
            <b>Micro-Residency</b>
          </span>
          <span className="microres-text-body MY-Body">
            <span>
              The micro-residency invites creative practitioners from all
              disciplines to engage in an intensive short-term residency
              exploring the theme <i>Machine Yearning</i>.<br></br>
              <br></br>
              This micro-residency is designed as a space for experimentation,
              dialogue, and collaboration across disciplines, encouraging
              participants to approach the theme from multiple perspectives —
              conceptual, material, technological, and embodied. Over the course
              of the program, residents will develop and share small-scale
              works, prototypes, performances, writings, or interventions that
              reflect their unique responses to the theme.
              <br></br>
              <br></br>
              The program culminates in an informal public sharing or open
              studio, where residents present their outcomes, processes, or
              questions-in-progress.
              <br></br>
              <br></br>
              For 2026, our invited artists are{" "}
              <a
                href="https://fawn-world.com/"
                target="_blank"
                rel="noreferrer noopener"
                className="ppl-link"
              >
                Fawn World
              </a>{" "}
              x{" "}
              <a
                href="https://hansclayground.com/"
                target="_blank"
                rel="noreferrer noopener"
                className="ppl-link"
              >
                Hans Chew
              </a>
              , and{" "}
            </span>
            <a
              href="https://www.instagram.com/soniakwek/?hl=en"
              target="_blank"
              rel="noreferrer noopener"
              className="ppl-link"
            >
              Sonia Kwek
            </a>
            .
          </span>
          <div className="microres-callout">
            <span className="microres-text-title MY-Body">SHARING SESSION</span>
            <div className="microres-callout-body">
              <span className="microres-text-title MY-Body">
                <b>
                  28 March
                  <br></br>
                  2pm – 5pm
                </b>
                <br></br>
              </span>
              <a
                href="https://forms.gle/BRJ9ktL3T4jHHRK77"
                target="_blank"
                rel="noreferrer noopener"
                className="microres-link MY-Body"
              >
                <span>REGISTER</span>
              </a>
            </div>
          </div>
          <span className="microres-text-body MY-Body">
            <i>Making Room</i> closes our 2026 season with an intimate gathering
            facilitated by{" "}
            <a
              href="https://www.instagram.com/snat.ty"
              target="_blank"
              rel="noreferrer noopener"
              className="ppl-link"
            >
              Natalie Sutanto
            </a>
            . Artists-in-residence Sonia Kwek, Hans Chew and Fawn World will
            share ongoing research undertaken during the residency, in dialogue
            with the practice of{" "}
            <a
              href="https://www.instagram.com/multistorycarepark/"
              target="_blank"
              rel="noreferrer noopener"
              className="ppl-link"
            >
              Genevieve Ong
            </a>
            , a community builder at{" "}
            <a
              href="https://forestschoolsingapore.com/"
              target="_blank"
              rel="noreferrer noopener"
              className="ppl-link"
            >
              Forest School Singapore
            </a>
            .<br></br>
            <br></br>
            Emerging from <i>How To Go On</i>, Feelers’ ongoing research into
            the quiet work of how to sustain ourselves, our creative practices,
            and each other, we open a shared inquiry into how we might make room
            enough to dream.
            <br></br>
            <br></br>
            We welcome artists, educators, community workers, and anyone curious
            about practices of spaceholding, placemaking, and making-in-place.
          </span>
          <span className="microres-text-title MY-Body">THE ARTISTS</span>
          <span className="MY-Subheader">Fawn World x Hans Chew</span>
          <span className="MY-Body">
            Fawn World and Hans Chew combine ceramics, found objects, and nature
            within contemporary vitrines, pairing the ever-changing temporality
            of perishable plants with longer-lasting ceramics to examine the
            vitrine as a technology of presentation which deepens attention.
          </span>
          <span className="MY-Subheader">Sonia Kwek</span>
          <span className="MY-Body">
            Sonia Kwek explores pole performance as an embodied relational
            technology at the interfaces between body pole, audience and
            performer, flowing through spectrums of pain/pleasure, risk/safety,
            exposure/concealment, and surrender/control.
          </span>
        </div>
      </div>
      <div className="microres-footer">
        <FooterB
          link={
            <Fragment>
              <span>
                © 2026 by Feelers. All Rights Reserved. Feelers is a project housed under The Digit, which is part of Potato Productions.
              </span>
            </Fragment>
          }
          link1={
            <Fragment>
              <span>More information about our Privacy Policy.</span>
            </Fragment>
          }
          rootClassName="footer-broot-class-name3"
        ></FooterB>
      </div>
    </div>
  );
};

export default MicroResidency;
